
import React, { useEffect, useState } from "react";
import api from "../../api/api";
import { useNavigate } from "react-router-dom";
import logo from "../../images/SPFLLOGO.png"; 

import ExcelExport from "../../UserControls/ExcelExport/ExcelExport";

export default function TicketSummary() {
  const [recentTickets, setRecentTickets] = useState([]);
  const [ticketSummary, setTicketSummary] = useState([]);
  const [loading, setLoading] = useState(true);
    const companyName = sessionStorage.getItem("companyName");
  const navigate = useNavigate();

  useEffect(() => {
    fetchTickets();
  }, []);

  const fetchTickets = async () => {
    try {
      const data = await api.RecentTicketsAPI("RecentTicketsReport", "admin");
      setRecentTickets(data.Table || []);
      setTicketSummary(data.Table1 || []);
    } catch (err) {
      console.error("Error fetching ticket data:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleEditService = (serviceId) => {
    if (serviceId && serviceId !== 0) {
      navigate(`/ServiceForm/${serviceId}`);
    } else {
      alert("This ticket does not have a linked Service Record yet.");
    }
  };

  const handleNewService = () => navigate("/TicketForm");

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="ticket-summary-container">
      <style>{`
        .ticket-summary-container {
          padding: 25px 30px;
          font-family: "Segoe UI", sans-serif;
          background: #f3f5f9;
          color: #333;
          min-height: 100vh;
        }

        .header-controls {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 20px;
          background: #fff;
          padding: 15px 20px;
          border-radius: 10px;
          box-shadow: 0 2px 6px rgba(0,0,0,0.1);
        }

        .page-title {
          font-size: 22px;
          font-weight: 600;
          margin: 0;
          color: #2c3e50;
          text-align:center;
        }

        .grid-container {
          display: grid;
          grid-template-columns: 1fr;
          gap: 25px;
        }

        .table-box {
          background: #fff;
          border-radius: 10px;
          box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
          overflow: hidden;
          transition: box-shadow 0.3s;
        }

        .table-box:hover {
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }

        .table-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background-color: #f7f9fb;
          padding: 10px 15px;
          border-bottom: 1px solid #ddd;
        }

        .table-title {
          font-size: 17px;
          font-weight: 600;
          color: #34495e;
          text-align:center;
        }

        .new-btn-header {
          background-color: #007bff;
          color: white;
          border: none;
          padding: 6px 14px;
          border-radius: 5px;
          cursor: pointer;
          font-size: 0.9em;
          font-weight: 500;
          transition: background-color 0.3s;
        }

        .new-btn-header:hover {
          background-color: #0056b3;
        }

        .table-content {
          max-height: 400px;
          overflow-y: auto;
          overflow-x: auto;
          scrollbar-width: thin;
          scrollbar-color: #ccc #f7f9fb;
        }

        .table-content::-webkit-scrollbar {
          height: 8px;
          width: 8px;
        }

        .table-content::-webkit-scrollbar-thumb {
          background: #bbb;
          border-radius: 10px;
        }

        .styled-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 14px;
        }

        .styled-table th,
        .styled-table td {
          border: 1px solid #e1e4e8;
          padding: 8px 10px;
          text-align: center;
        }

        .styled-table th {
          background: #eef2f6;
          position: sticky;
          top: 0;
          z-index: 5;
        }

        .styled-table tr:nth-child(even) {
          background: #fafbfc;
        }

        .styled-table tr:hover {
          background: #f0f7ff;
        }

        .action-cell {
          text-align: center;
        }

        .edit-btn {
          background: #3498db;
          color: white;
          border: none;
          border-radius: 4px;
          padding: 4px 8px;
          font-size: 0.8em;
          cursor: pointer;
          transition: all 0.2s;
        }

        .edit-btn:hover {
          background: #217dbb;
          transform: translateY(-1px);
        }

        .no-data {
          text-align: center;
          padding: 12px;
          color: #888;
        }

        .loading {
          text-align: center;
          padding: 20px;
          color: #666;
        }


        /* 📱 Mobile & Tablet Responsive Enhancements */
@media (max-width: 1024px) {
  .header-controls {
    flex-direction: column;
    align-items: center;
    padding: 10px;
    text-align: center;
  }

  .header-controls td {
    justify-content: center !important;
    padding-right: 0 !important;
    margin-bottom: 8px;
  }

  .header-controls img {
    width: 50px !important;
    height: 50px !important;
  }

  .header-controls h1 {
    font-size: 18px !important;
  }

  .page-title {
    font-size: 20px;
    margin-top: 5px;
  }

  .grid-container {
    gap: 20px;
  }

  .table-header {
    flex-direction: column;
    gap: 10px;
  }

  .table-title {
    font-size: 16px;
  }

  .new-btn-header,
  .edit-btn {
    font-size: 0.85rem;
    padding: 6px 10px;
  }

  .table-content {
    overflow-x: auto;
  }

  .styled-table {
    min-width: 900px;
  }

  .ticket-summary-container {
    padding: 15px;
  }
}

@media (max-width: 600px) {
  .header-controls {
    flex-direction: column;
    padding: 8px;
  }

  .header-controls td {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .header-controls img {
    width: 45px !important;
    height: 45px !important;
    margin-bottom: 5px;
  }

  .header-controls h1 {
    font-size: 16px !important;
  }

  .page-title {
    font-size: 1.1rem;
  }

  .table-header {
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  .new-btn-header {
    width: 100%;
  }

  .table-title {
    text-align: center;
  }

  .table-content {
    overflow-x: auto;
  }

  .styled-table {
    min-width: 700px;
  }

  .edit-btn {
    width: 100%;
  }

  .ticket-summary-container {
    padding: 10px;
  }

  .grid-container {
    gap: 15px;
  }
}


      `}</style>

      <div className="header-controls">
         <td
                colSpan="2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  paddingRight: "800px",
                }}
              >
                {/* <img
                  src={logo}
                  alt="Company Logo"
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    backgroundColor: "white",
                    boxShadow: "0 0 4px rgba(0,0,0,0.2)",
                    padding: "5px",
                    marginRight: "1px",
                    objectFit: "contain",
                  }}
                /> */}
                <h1
                  style={{
                    fontSize: "22px",
                    fontWeight: "bold",
                    color: "#333",
                    margin: 0,
                    textAlign: "left",
                  }}
                >
                  {companyName}
                </h1>
              </td>
        <h2 className="page-title">Ticket Summary</h2>
      </div>

      <div className="grid-container">
        {/* Recent Tickets */}
        <div className="table-box">
          <div className="table-header">
            <button className="new-btn-header" onClick={handleNewService}>+ New</button>
            <h3 className="table-title">Recent Tickets</h3>
             <ExcelExport data={recentTickets} fileName="RecentTickets" />
          </div>
          <div className="table-content">
            <table className="styled-table">
              <thead>
                <tr>
                  <th>Action</th>
                  <th>SlNo</th>
                  <th>Ticket No</th>
                  <th>Issue</th>
                  <th>Asset</th>
                  <th>Priority</th>
                  <th>Status</th>
                  <th>Status Time</th>
                  <th>Open Time</th>
                  <th>Closing Time</th>
                  <th>Breakdown Hours</th>
                </tr>
              </thead>
              <tbody>
                {recentTickets.length > 0 ? (
                  recentTickets.map((t) => (
                    <tr key={t.TicketId}>
                      <td className="action-cell">
                        <button
                          className="edit-btn"
                          onClick={() => handleEditService(t.serviceid)}
                          title={`Edit Service for Ticket ${t.TicketNo}`}
                        >
                          ✏️ Edit
                        </button>
                      </td>
                      <td>{t.Slno}</td>
                      <td style={{ textAlign: "left" }}>{t.TicketNo}</td>
                      <td style={{ textAlign: "left" }}>{t.IssueTitle}</td>
                      <td style={{ textAlign: "left" }}>{t.AssetName}</td>
                      <td>{t.Priority}</td>
                      <td>{t.Status}</td>
                      <td>{t.Time}</td>
                      <td>{t.OpenTime}</td>
                      <td>{t.Closetime}</td>
                      <td>{t.BDHours}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="11" className="no-data">
                      No recent tickets found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Ticket Summary */}
        <div className="table-box">
          <div className="table-header">
            <h3 className="table-title">Ticket Summary</h3>
            <ExcelExport data={ticketSummary} fileName="TicketSummary" />
          </div>
          <div className="table-content">
            <table className="styled-table">
              <thead>
                <tr>
                  <th>Department</th>
                  <th>Tickets</th>
                  <th>Opened</th>
                  <th>In Process</th>
                  <th>Pending</th>
                  <th>Verified</th>
                  <th>Completed</th>
                  <th>Closed</th>
                  <th>Not Taken Yet</th>
                </tr>
              </thead>
              <tbody>
                {ticketSummary.length > 0 ? (
                  ticketSummary.map((s, index) => (
                    <tr key={index}>
                      <td>{s.Department}</td>
                      <td>{s.Tickets}</td>
                      <td>{s.Opened}</td>
                      <td>{s.InProcess}</td>
                      <td>{s.Pending}</td>
                      <td>{s.Verified}</td>
                      <td>{s.Completed}</td>
                      <td>{s.Closed}</td>
                      <td>{s.NotTakenYet}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="no-data">
                      No summary data found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}



// import React, { useEffect, useState } from "react";
// import api from "../../api/api";
// import { useNavigate } from "react-router-dom";
// import logo from "../../images/SPFLLOGO.png"; 

// import ExcelExport from "../../UserControls/ExcelExport/ExcelExport";

// export default function TicketSummary() {
//   const [recentTickets, setRecentTickets] = useState([]);
//   const [ticketSummary, setTicketSummary] = useState([]);
//   const [loading, setLoading] = useState(true);
//     const companyName = sessionStorage.getItem("companyName");
//   const navigate = useNavigate();

//   useEffect(() => {
//     fetchTickets();
//   }, []);

//   const fetchTickets = async () => {
//     try {
//       const data = await api.RecentTicketsAPI("RecentTicketsReport", "admin");
//       setRecentTickets(data.Table || []);
//       setTicketSummary(data.Table1 || []);
//     } catch (err) {
//       console.error("Error fetching ticket data:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEditService = (serviceId) => {
//     if (serviceId && serviceId !== 0) {
//       navigate(`/ServiceForm/${serviceId}`);
//     } else {
//       alert("This ticket does not have a linked Service Record yet.");
//     }
//   };

//   const handleNewService = () => navigate("/TicketForm");

//   if (loading) return <div className="loading">Loading...</div>;

//   return (
//     <div className="ticket-summary-container">
//       <style>{`
//         .ticket-summary-container {
//           padding: 25px 30px;
//           font-family: "Segoe UI", sans-serif;
//           background: #f3f5f9;
//           color: #333;
//           min-height: 100vh;
//         }

//         .header-controls {
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           margin-bottom: 20px;
//           background: #fff;
//           padding: 15px 20px;
//           border-radius: 10px;
//           box-shadow: 0 2px 6px rgba(0,0,0,0.1);
//         }

//         .page-title {
//           font-size: 22px;
//           font-weight: 600;
//           margin: 0;
//           color: #2c3e50;
//           text-align:center;
//         }

//         .grid-container {
//           display: grid;
//           grid-template-columns: 1fr;
//           gap: 25px;
//         }

//         .table-box {
//           background: #fff;
//           border-radius: 10px;
//           box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
//           overflow: hidden;
//           transition: box-shadow 0.3s;
//         }

//         .table-box:hover {
//           box-shadow: 0 4px 12px rgba(0,0,0,0.15);
//         }

//         .table-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           background-color: #f7f9fb;
//           padding: 10px 15px;
//           border-bottom: 1px solid #ddd;
//         }

//         .table-title {
//           font-size: 17px;
//           font-weight: 600;
//           color: #34495e;
//           text-align:center;
//         }

//         .new-btn-header {
//           background-color: #007bff;
//           color: white;
//           border: none;
//           padding: 6px 14px;
//           border-radius: 5px;
//           cursor: pointer;
//           font-size: 0.9em;
//           font-weight: 500;
//           transition: background-color 0.3s;
//         }

//         .new-btn-header:hover {
//           background-color: #0056b3;
//         }

//         .table-content {
//           max-height: 400px;
//           overflow-y: auto;
//           overflow-x: auto;
//           scrollbar-width: thin;
//           scrollbar-color: #ccc #f7f9fb;
//         }

//         .table-content::-webkit-scrollbar {
//           height: 8px;
//           width: 8px;
//         }

//         .table-content::-webkit-scrollbar-thumb {
//           background: #bbb;
//           border-radius: 10px;
//         }

//         .styled-table {
//           width: 100%;
//           border-collapse: collapse;
//           font-size: 14px;
//         }

//         .styled-table th,
//         .styled-table td {
//           border: 1px solid #e1e4e8;
//           padding: 8px 10px;
//           text-align: center;
//         }

//         .styled-table th {
//           background: #eef2f6;
//           position: sticky;
//           top: 0;
//           z-index: 5;
//         }

//         .styled-table tr:nth-child(even) {
//           background: #fafbfc;
//         }

//         .styled-table tr:hover {
//           background: #f0f7ff;
//         }

//         .action-cell {
//           text-align: center;
//         }

//         .edit-btn {
//           background: #3498db;
//           color: white;
//           border: none;
//           border-radius: 4px;
//           padding: 4px 8px;
//           font-size: 0.8em;
//           cursor: pointer;
//           transition: all 0.2s;
//         }

//         .edit-btn:hover {
//           background: #217dbb;
//           transform: translateY(-1px);
//         }

//         .no-data {
//           text-align: center;
//           padding: 12px;
//           color: #888;
//         }

//         .loading {
//           text-align: center;
//           padding: 20px;
//           color: #666;
//         }
//       `}</style>

//       <div className="header-controls">
//          <td
//                 colSpan="2"
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "flex-end",
//                   paddingRight: "800px",
//                 }}
//               >
//                 <img
//                   src={logo}
//                   alt="Company Logo"
//                   style={{
//                     width: "60px",
//                     height: "60px",
//                     borderRadius: "50%",
//                     backgroundColor: "white",
//                     boxShadow: "0 0 4px rgba(0,0,0,0.2)",
//                     padding: "5px",
//                     marginRight: "1px",
//                     objectFit: "contain",
//                   }}
//                 />
//                 <h1
//                   style={{
//                     fontSize: "22px",
//                     fontWeight: "bold",
//                     color: "#333",
//                     margin: 0,
//                     textAlign: "left",
//                   }}
//                 >
//                   {companyName}
//                 </h1>
//               </td>
//         <h2 className="page-title">Ticket Summary</h2>
//       </div>

//       <div className="grid-container">
//         {/* Recent Tickets */}
//         <div className="table-box">
//           <div className="table-header">
//             <button className="new-btn-header" onClick={handleNewService}>+ New</button>
//             <h3 className="table-title">Recent Tickets</h3>
//              <ExcelExport data={recentTickets} fileName="RecentTickets" />
//           </div>
//           <div className="table-content">
//             <table className="styled-table">
//               <thead>
//                 <tr>
//                   <th>Action</th>
//                   <th>SlNo</th>
//                   <th>Ticket No</th>
//                   <th>Issue</th>
//                   <th>Asset</th>
//                   <th>Priority</th>
//                   <th>Status</th>
//                   <th>Status Time</th>
//                   <th>Open Time</th>
//                   <th>Closing Time</th>
//                   <th>Breakdown Hours</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {recentTickets.length > 0 ? (
//                   recentTickets.map((t) => (
//                     <tr key={t.TicketId}>
//                       <td className="action-cell">
//                         <button
//                           className="edit-btn"
//                           onClick={() => handleEditService(t.serviceid)}
//                           title={`Edit Service for Ticket ${t.TicketNo}`}
//                         >
//                           ✏️ Edit
//                         </button>
//                       </td>
//                       <td>{t.Slno}</td>
//                       <td style={{ textAlign: "left" }}>{t.TicketNo}</td>
//                       <td style={{ textAlign: "left" }}>{t.IssueTitle}</td>
//                       <td style={{ textAlign: "left" }}>{t.AssetName}</td>
//                       <td>{t.Priority}</td>
//                       <td>{t.Status}</td>
//                       <td>{t.Time}</td>
//                       <td>{t.OpenTime}</td>
//                       <td>{t.Closetime}</td>
//                       <td>{t.BDHours}</td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="11" className="no-data">
//                       No recent tickets found.
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* Ticket Summary */}
//         <div className="table-box">
//           <div className="table-header">
//             <h3 className="table-title">Ticket Summary</h3>
//             <ExcelExport data={ticketSummary} fileName="TicketSummary" />
//           </div>
//           <div className="table-content">
//             <table className="styled-table">
//               <thead>
//                 <tr>
//                   <th>Department</th>
//                   <th>Tickets</th>
//                   <th>Opened</th>
//                   <th>In Process</th>
//                   <th>Pending</th>
//                   <th>Verified</th>
//                   <th>Completed</th>
//                   <th>Closed</th>
//                   <th>Not Taken Yet</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {ticketSummary.length > 0 ? (
//                   ticketSummary.map((s, index) => (
//                     <tr key={index}>
//                       <td>{s.Department}</td>
//                       <td>{s.Tickets}</td>
//                       <td>{s.Opened}</td>
//                       <td>{s.InProcess}</td>
//                       <td>{s.Pending}</td>
//                       <td>{s.Verified}</td>
//                       <td>{s.Completed}</td>
//                       <td>{s.Closed}</td>
//                       <td>{s.NotTakenYet}</td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="9" className="no-data">
//                       No summary data found.
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
